import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type { MatchPlan } from './match-plan.type.ts';

// NB: backend class that models this is the ruby Jsonb::GenericTextStore
export interface MatchPlanExtension extends MatchPlan {}
export class MatchPlanExtension {
  @service declare intl: IntlService;

  /**************************
   **  Computed Properties **
   **************************/
  get ensureVerifyAccountStatement() {
    return (
      this.verifyAccountStatement || this.intl.t('syf.shared.match_plan.default_verify_statement')
    );
  }
}

const Registration = {
  kind: 'object',
  name: 'match-plan',
  features: MatchPlanExtension,
};
export default Registration;
